import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
// TODO should be fixed with polyfill link when header-footer-provider will be implemented

export function removeElement(element: HTMLElement) {
  if (element.remove) {
    // @ts-ignore
    return element.remove();
  }
  return element.parentElement?.removeChild(element);
}

export function findClosestElementBySelector(element: HTMLElement, selector: string) {
  if (Element.prototype.closest) {
    return Element.prototype.closest.call(element, selector);
  }

  let el: Element | null | (Node & ParentNode) = element;
  let matches = Element.prototype.matches;
  if (!matches) {
    matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  do {
    if (matches.call(el, selector)) {
      return el;
    }
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
}
